import httpRequest from "services/httpRequest";

const prefix = "/api/service-voice-setting";

export const onUpdateServiceVoiceSetting = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params?.id}`,
    method: "PUT",
    data: params,
    // successMessage: "toast.update_success",
  });
  return result;
};

export const onGetVoiceSettingDetail = async params => {
  const result = await httpRequest({
    url: `${prefix}/service/${params?.serviceId}`,
    method: "GET",
  });
  if (!result) {
    return result;
  }
  return result?.data;
};
